import { render, staticRenderFns } from "./BindBank.vue?vue&type=template&id=66b8b258&scoped=true&"
import script from "./BindBank.vue?vue&type=script&lang=js&"
export * from "./BindBank.vue?vue&type=script&lang=js&"
import style0 from "./BindBank.vue?vue&type=style&index=0&id=66b8b258&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b8b258",
  null
  
)

component.options.__file = "BindBank.vue"
export default component.exports